import React__default from 'react';
import styled from 'styled-components';
import { CSSGeneratePadding, CSSGenerateMargin, CSSGenerateVisibility } from '../styles/cssGenerate.js';
import { getResponsiveProps, useActiveResponsiveProp } from '../styles/useResponsiveProps.js';

/**
 * Styled Components
 */ const VisuallyHiddenWrapper = styled.span`
  /* TODO: consolidate with Box implementation */
  ${(props)=>props.padding !== undefined ? CSSGeneratePadding(props.padding) : ""}
  ${(props)=>props.margin !== undefined ? CSSGenerateMargin(props.margin) : ""}
  ${(props)=>props.visibility !== undefined ? getResponsiveProps(props.visibility)(CSSGenerateVisibility) : ""}
  ${(props)=>props.height === "fill" && "height: 100%;"}
  ${(props)=>props.width === "fill" && "width: 100%;"}
`;
/**
 * Component that is hidden to the user.
 * Content inside of the Hidden component should be readable by screen readers. (Untested)
 *
 * @param visible - ResponsiveProp<'hidden' | 'visible'>
 * Defaults to 'hidden'
 *
 * @example
 * <Hidden>Text here</Hidden>
 *
 * Hide based on window size
 * <Hidden visible={['hidden', 'hidden', 'visible']}>Text here</Hidden>
 */ const VisuallyHidden = ({ visibility ="hidden" , inline =true , children , ...props })=>{
    const activeVisibility = useActiveResponsiveProp(visibility);
    return React__default.createElement(VisuallyHiddenWrapper, {
        "data-hpy-web-hidden": true,
        "data-hpy-web-visually-hidden": true,
        ...activeVisibility === "hidden" ? {
            "data-hpy-web-hidden-is-hidden": ""
        } : {},
        ...props,
        visibility: visibility,
        as: inline ? "span" : "div"
    }, children);
};
VisuallyHidden.dataId = "data-hpy-web-visually-hidden";
VisuallyHidden.displayName = "VisuallyHidden";

export { VisuallyHidden };
